import { IListingStatsResponse } from "../../../../models/Part";
import DashboardTile from "../../../dashboard/DashboardTile";

export default function ListedMissingTable({ listingStats, }: { listingStats: IListingStatsResponse; }) {

  const missingFields = [
    { key: "MPN", label: "MPN" },
    { key: "OEMPN", label: "OEMPN" },
    { key: "Brand", label: "Brand" },
    { key: "Make", label: "Make" },
    { key: "Model", label: "Model" },
    { key: "VIN", label: "VIN" },
    { key: "Grade", label: "Grade" },
    { key: "KType", label: "KType" },
  ];

  const renderMissingTable = () => (
    <table className="min-w-full border-collapse">
      <thead>
        <tr className="border-b border-gray-300 text-left text-sm font-semibold text-gray-700">
          <th className="py-2 px-3 w-1/2">Field</th>
          <th className="py-2 px-3 text-right">Missing Count</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {missingFields.map((field) => {
          const count = listingStats.listingsMissing[field.key] || 0;
          return (
            <tr key={field.key}>
              <td className="py-2 px-3 font-medium text-gray-900">
                {field.label}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {count}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <DashboardTile span={1}>
      <div className="">
        <div className="mb-4 flex items-center justify-between">
          <div className="prose">
            <h3 className="m-0">Missing Fields</h3>
          </div>
        </div>

        <div className="overflow-x-auto overflow-y-scroll max-h-[25vh]">
          {renderMissingTable()}
        </div>
      </div>
    </DashboardTile>
  );
}

